{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-github-oauth-ui",
  "version": "7.2.0",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "run-s update start",
    "docker": "bash run docker_",
    "fix": "run-s format typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "run-s prepack copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"bun dev\""
  },
  "dependencies": {
    "@npmcli/config": "^11.0.1",
    "@octokit/oauth-methods": "^6.0.4",
    "@octokit/request": "^10.0.15",
    "@verdaccio/core": "^8.3.0",
    "@verdaccio/url": "^13.1.3",
    "dotenv": "^17.4.2",
    "express": "^5.2.1",
    "lodash": "^4.18.1",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^5.0.5",
    "open": "^11.0.1",
    "ow": "^3.1.1",
    "picocolors": "^1.1.1",
    "query-string": "^9.5.0",
    "undici": "^8.10.0"
  },
  "devDependencies": {
    "@parcel/config-default": "^2.16.4",
    "@types/express": "^5.0.6",
    "@types/lodash": "^4.17.25",
    "@types/memory-cache": "^0.2.6",
    "@types/minimist": "^1.2.5",
    "@types/node": "^26.4.0",
    "@types/npmcli__config": "^6.0.4",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^13.0.6",
    "@vitest/coverage-v8": "^4.1.11",
    "browserslist": "^4.28.8",
    "core-js": "^3.50.0",
    "nodemon": "^3.1.14",
    "npm-run-all2": "^9.0.3",
    "parcel": "^2.16.4",
    "prettier": "^3.9.6",
    "process": "^0.11.10",
    "release-it": "^21.0.2",
    "timekeeper": "^2.3.1",
    "type-fest": "^5.8.0",
    "typescript": "^7.0.2",
    "verdaccio": "^7.0.2",
    "verdaccio-htpasswd": "^13.1.3",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.11"
  },
  "peerDependencies": {
    "verdaccio": ">=6"
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-6.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
